
import React, { useEffect, useState } from "react";
// react plugin for creating charts
import ChartistGraph from "react-chartist";
// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";
import Icon from "@material-ui/core/Icon";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Typography from "@material-ui/core/Typography";
// @material-ui/icons
import Store from "@material-ui/icons/Store";
import Warning from "@material-ui/icons/Warning";
import DateRange from "@material-ui/icons/DateRange";
import LocalOffer from "@material-ui/icons/LocalOffer";
import Update from "@material-ui/icons/Update";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import AccessTime from "@material-ui/icons/AccessTime";
import Accessibility from "@material-ui/icons/Accessibility";
import BugReport from "@material-ui/icons/BugReport";
import Code from "@material-ui/icons/Code";
import Cloud from "@material-ui/icons/Cloud";
import Visibility from "@material-ui/icons/Visibility";
import People from "@material-ui/icons/People";
import Assignment from "@material-ui/icons/Assignment";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Table from "components/Table/Table.js";
import Tasks from "components/Tasks/Tasks.js";
import CustomTabs from "components/CustomTabs/CustomTabs.js";
import Danger from "components/Typography/Danger.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";

import { bugs, website, server } from "variables/general.js";

import {
  dailySalesChart,
  emailsSubscriptionChart,
  completedTasksChart,
} from "variables/charts.js";

import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import { use } from "react";
import { fetchAdminAndManagerStatistics } from "views/Apis/AfterLogin";

const useStyles = makeStyles(styles);

export default function AdminDashboard() {
  const classes = useStyles();
  const userId = sessionStorage.getItem("userId");
  const role = sessionStorage.getItem("userRole");

  const [adminStats, setAdminStats] = useState({
    totalLeads: 0,
    totalManagers: 0,
    totalEmployess: 0,
    unassignedLeadsToManager: 0,
    managerStats: [],
    employeeStats: []
  });



  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  useEffect(() => {
    const data = {
      userId: userId,
      role: role
    };

    const fetchData = async () => {
      try {
        const res = await fetchAdminAndManagerStatistics(data);
        console.log("Admin Statistics:", res);

        // Update state with API response
        if (res) {
          setAdminStats(res);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleShowEmployeeStats = (employee) => {
    setSelectedEmployee(employee);
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
    setSelectedEmployee(null);
  };

  // Prepare manager table data
  const managerTableData = adminStats.managerStats.map(manager => [
    manager.userId,
    manager.userName,
    manager.leadCount.toString(),
    "Manager"]);

  // Prepare employee table data
  const employeeTableData = adminStats.employeeStats.map(employee => [
    employee.userId,
    employee.userName,
    employee.leadCount.toString(),
    "Employee",
    <Button
      key={employee.userId}
      variant="contained"
      color="secondary"
      size="small"
      startIcon={<Visibility />}
      onClick={() => handleShowEmployeeStats(employee)}
    >
      Stats
    </Button>
  ]);

  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="warning" stats icon>
              <CardIcon color="warning">
                <Icon>content_copy</Icon>
              </CardIcon>
              <p className={classes.cardCategory}>Total Leads</p>
              <h3 className={classes.cardTitle}>{adminStats.totalLeads}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Danger>
                  <Warning />
                </Danger>
                <a href="#pablo">
                  View Details
                </a>
              </div>
            </CardFooter>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="success" stats icon>
              <CardIcon color="success">
                <People />
              </CardIcon>
              <p className={classes.cardCategory}>Total Managers</p>
              <h3 className={classes.cardTitle}>{adminStats.totalManagers}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <DateRange />
                Active
              </div>
            </CardFooter>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <Accessibility />
              </CardIcon>
              <p className={classes.cardCategory}>Total Employees</p>
              <h3 className={classes.cardTitle}>{adminStats.totalEmployess}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <LocalOffer />
                Active
              </div>
            </CardFooter>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="danger" stats icon>
              <CardIcon color="danger">
                <Assignment />
              </CardIcon>
              <p className={classes.cardCategory}>Unassigned Leads To Managers</p>
              <h3 className={classes.cardTitle}>{adminStats.unassignedLeadsToManager}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Update />
                Pending Assignment
              </div>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12} sm={12} md={6}>
          <Card>
            <CardHeader color="warning">
              <h4 className={classes.cardTitleWhite}>Manager Statistics</h4>
              <p className={classes.cardCategoryWhite}>
                Manager performance and lead assignments
              </p>
            </CardHeader>
            <CardBody>
              <Table
                tableHeaderColor="warning"
                tableHead={["User ID", "Name", "Lead Count", "Role"]}
                tableData={managerTableData}
              />
            </CardBody>
          </Card>
        </GridItem>


<GridItem xs={12} sm={12} md={6}>
          <Card>
            <CardHeader color="info">
              <h4 className={classes.cardTitleWhite}>Employee Statistics</h4>
              <p className={classes.cardCategoryWhite}>
                Employee performance and lead assignments
              </p>
            </CardHeader>
            <CardBody>
              <Table
                tableHeaderColor="info"
                tableHead={["User ID", "Name", "Lead Count", "Role", "Actions"]}
                tableData={employeeTableData}
              />
            </CardBody>
          </Card>
        </GridItem>

      </GridContainer>



      {/* Employee/Manager Statistics Popup */}
      <Dialog
        open={isPopupOpen}
        onClose={handleClosePopup}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          {selectedEmployee ? `${selectedEmployee.userName} - Statistics` : "Statistics"}
        </DialogTitle>
        <DialogContent>
          {selectedEmployee && (
            <div>
              <Typography variant="h6" gutterBottom>
                User Details
              </Typography>
              <Typography variant="body1" paragraph>
                <strong>User ID:</strong> {selectedEmployee.userId}
              </Typography>
              <Typography variant="body1" paragraph>
                <strong>Name:</strong> {selectedEmployee.userName}
              </Typography>
              <Typography variant="body1" paragraph>
                <strong>Lead Count:</strong> {selectedEmployee.leadCount}
              </Typography>

              <Typography variant="h6" gutterBottom style={{ marginTop: 20 }}>
                Performance Metrics
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Additional statistics will be integrated here once the detailed API is available.
                This will include conversion rates, call logs, follow-up statistics, etc.
              </Typography>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClosePopup} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}